import Service from "../service";

const lessons = {
  onGetLessons(id, userId) {
    return Service.get(`/lessons/${id}`, { 
      params: { user_id: userId },
    });
  },
  onSaveLessonProgress(model, accessToken) {
    return Service.post(`/course/lesson-progress`, model, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
  onSaveLessonYouTubeProgress(model, accessToken) {
    return Service.post(`/course/lesson-youtube-progress`, model, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
  onSaveLessonH5pProgress(model, accessToken) {
    return Service.post(`/course/lesson-h5p-progress`, model, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
};

export default lessons;
